import { render, staticRenderFns } from "./FaceBadLighting.vue?vue&type=template&id=21963c62&scoped=true"
var script = {}
import style0 from "./FaceBadLighting.vue?vue&type=style&index=0&id=21963c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21963c62",
  null
  
)

export default component.exports